export default __webpack_public_path__ + "assets/images/201e5ff261df936b3e02b037560b176f.png";